import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watchEffect } from 'vue';
import { useRoute, useRouter } from '@nuxtjs/composition-api';

interface Props {
  title?: string;
  description?: string;
}
interface Emits {
  (e: 'search', data: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchHeader',
  props: {
    title: null,
    description: null
  },
  emits: ["search"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'search', data: string): void;
}), expose: any, slots: any, attrs: any }) {




const router = useRouter();
const route = useRoute();
const searchQuery = computed(() => (route.value.query.search as string) ?? '');
const searchText = ref('');

const search = (searchString: string | undefined) => {
  router.push({
    query: {
      search: searchString || undefined,
    },
  });
  emit('search', searchText.value);
};
watchEffect(() => {
  searchText.value = searchQuery.value;
});

return { __sfc: true,emit, router, route, searchQuery, searchText, search }
}

})